import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
const MessageRow = styled.tr`
  text-align: center;
`;

const MessageTd = styled.td`
  padding: 20px;
  font-style: italic;
`;
const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-radius: 10px;
`;

const Title = styled.h2`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
`; 

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: white;
  overflow: hidden;
`;

const Th = styled.th`
  background-color: #3498db;
  color: white;
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
`;

const TimerTd = styled(Td)`
  color: ${(props) => (props.isCritical ? 'red' : 'black')};
`;

const Button = styled.button`
  padding: 8px 16px;
  margin: 4px;
  font-size: 14px;
  color: white;
  background-color: #007BFF;
  border: none;
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

function CouponUsageHistory(){
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBuyCoupon = async () => {

    };

    fetchBuyCoupon();

    const intervalId = setInterval(() => {
      setRows((prevRows) =>
        prevRows.map((row) => {
          const remainingTime = calculateRemainingTime(row.end_time);
          return { ...row, remainingTime };
        })
      );
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const calculateRemainingTime = (endTime) => {
    const end = new Date(endTime);
    const now = new Date();
    const diff = end - now;

    if (diff <= 0) return 'Expired';

    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };


  return (
    <Container>
      <Title>쿠폰 구매하기</Title>
      <Table>
        <thead>
          <tr>
            <Th>컬럼1</Th>
            <Th>컬럼2</Th>
            <Th>컬럼3</Th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <MessageRow>
              <MessageTd colSpan="8">쿠폰 사용 내역이 없습니다.  </MessageTd>
            </MessageRow>
          ) : rows.map((item) => (
            <tr key={item.menu_id}> {/* menu_id로 변경 */}
              <TimerTd isCritical={item.remainingTime && item.remainingTime.split(':')[0] === '0' && parseInt(item.remainingTime.split(':')[1]) <= 59}>
                {item.remainingTime || calculateRemainingTime(item.end_time)}
              </TimerTd>
              <Td>
              </Td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default CouponUsageHistory;
